import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LocationInterface } from 'app/models/location.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { LocationDataTransformPost } from './data-transforms/locations.data.transform.post';
import { LocationDataTransformGet } from './data-transforms/locations.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class LocationsHttpInterceptor implements HttpInterceptor {
  private readonly _transformDown = inject(LocationDataTransformPost);
  private readonly _transformUp = inject(LocationDataTransformGet);

  private readonly _rexp = new RegExp(/^\/locations(\/[0-9a-z]{24})?$/);

  intercept(req: HttpRequest<LocationInterface>, next: HttpHandler): Observable<HttpEvent<LocationInterface>> {
    return RequestService.getTransformedHttpEvent<LocationInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
